export default __webpack_public_path__ + "static/media/page.bead44bf.jpg";